import createApiClient from './apiClient';

const userApi = createApiClient(process.env.REACT_APP_ATHENIAN_USER_SERVICE_URL);

export const createUser = (data) =>
  userApi.post('/', data);

export const getUsers = (params) =>
  userApi.get('/', { params });

export const getUser = (userId) =>
  userApi.get(`/${userId}`);

export const updateUser = (userId, data) =>
  userApi.put(`/${userId}`, data);

export const deleteUser = (userId) =>
  userApi.delete(`/${userId}`);

export const streamUserProfileImage = async (userId) => {
  const res = await userApi.get(`/${userId}/profile-image`, { responseType: 'blob' });
  return res.data;
};

export const uploadProfileImage = (userId, file) => {
  const form = new FormData();
  form.append('profile_image', file);
  return userApi.post(`/${userId}/profile-image`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
